/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePaymentMethodData
 */
export interface CreatePaymentMethodData {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodData
     */
    stripeCheckoutSessionId: string;
}

/**
 * Check if a given object implements the CreatePaymentMethodData interface.
 */
export function instanceOfCreatePaymentMethodData(value: object): value is CreatePaymentMethodData {
    if (!('stripeCheckoutSessionId' in value) || value['stripeCheckoutSessionId'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodDataFromJSON(json: any): CreatePaymentMethodData {
    return CreatePaymentMethodDataFromJSONTyped(json, false);
}

export function CreatePaymentMethodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodData {
    if (json == null) {
        return json;
    }
    return {
        
        'stripeCheckoutSessionId': json['stripeCheckoutSessionId'],
    };
}

  export function CreatePaymentMethodDataToJSON(json: any): CreatePaymentMethodData {
      return CreatePaymentMethodDataToJSONTyped(json, false);
  }

  export function CreatePaymentMethodDataToJSONTyped(value?: CreatePaymentMethodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stripeCheckoutSessionId': value['stripeCheckoutSessionId'],
    };
}

